import React from "react";

const FilterSearch = ({
                          label = "Location",
                          id = "formGroupExampleInput",
                          placeholder = "Search location",
                          value = "",
                          pbInput,
                          onChange,
                          widthClass = "w-100", // por defecto que ocupe todo
                      }) => {
    return (
        <div className={`mb-2 ${widthClass}`}>
            <label htmlFor={id} className="form-label fs-6">{label}</label>
            <input
                type="text"
                className={`form-control bg-light border-light shadow-none py-2 rounded ${pbInput}`}
                id={id}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
            />
        </div>
    );
};

export default FilterSearch;